import React from 'react';
import './Button.css';

const ViewDetailsBtn = ({ onClick }) => {
  return (
    <button className="view-details-btn" onClick={onClick}>
      View Details
    </button>
  );
};

export default ViewDetailsBtn;